import config from '@/config'

import number01 from '@/assets/img/number/01.png'
import number02 from '@/assets/img/number/02.png'
import number01H5 from '@/assets/img/number/m_cer-one.png'
import number02H5 from '@/assets/img/number/m_cer-two.png'
import cert1Img from '@/assets/img/number/cert1.png'
import cert2Img from '@/assets/img/number/cert2.png'
import cert1ImgH5 from '@/assets/img/number/m_cer-title-one.png'
import cert2ImgH5 from '@/assets/img/number/m_cer-title-two.png'

import harvest1Img from '@/assets/img/number/harvest1.png'
import harvest2Img from '@/assets/img/number/harvest2.png'
import harvest3Img from '@/assets/img/number/harvest3.png'

import book1Img from '@/assets/img/number/book1.png'
import book2Img from '@/assets/img/number/book2.png'
import book3Img from '@/assets/img/number/book3.png'
import book4Img from '@/assets/img/number/book4.png'
import book5Img from '@/assets/img/number/book5.png'
import book6Img from '@/assets/img/number/book6.png'
import column1Img from '@/assets/img/number/column1.png'
import column2Img from '@/assets/img/number/column2.png'

import lijia from '@/assets/img/number/avatar/lijia.png'
import wangyipeng from '@/assets/img/number/avatar/wangyipeng.png'
import gaoyuxian from '@/assets/img/number/avatar/gaoyuxian.png'
import yanting from '@/assets/img/number/avatar/yanting.png'

import chenxiaohua from '@/assets/img/number/avatar/chenxiaohua.png'
import liushaoxuan from '@/assets/img/number/avatar/liushaoxuan.png'
import shikai from '@/assets/img/number/avatar/shikai.png'
import wangnan from '@/assets/img/number/avatar/wangnan.png'
import wangwei from '@/assets/img/number/avatar/wangwei.png'
import zhuyingshao from '@/assets/img/number/avatar/zhuyingshao.png'
import qiaoxinliang from '@/assets/img/number/avatar/qiaoxinliang.png'
import shenyang from '@/assets/img/number/avatar/shenyang.png'
import xiangjiangxu from '@/assets/img/number/avatar/xiangjiangxu.png'

// 重点工作方向
const directionList = [
  {
    title: '标准与中小企业服务生态建设',
    titleBg: 'linear-gradient(224deg, #B7D4FF 0%, #428AFF 100%)',
    intro: '极客邦科技将主动参与<strong>工业和信息化重点领域数字化转型产业人才基地、中国移动通信联合会 “ ICT 行业讲师评定认证项目”</strong> 的标准研究工作，支撑打造高质量具有代表性和先进性的数字化转型产业人才相关标准。'
  },
  {
    title: '数字化转型产业人才培养内容研发与推广',
    titleBg: 'linear-gradient(90deg, #EC6101 0%, #FFDDC6 100%)',
    intro: '极客邦双数研究院持续关注国家数字经济政策与发展趋势对产业的影响，以及对人才技能要求的变化，与企业共创数字人才战略及培养体系，为推动企业数字化转型深度赋能。'
  },
  {
    title: '数字化稀缺复合型人才培训内容与模式研究',
    titleBg: 'linear-gradient(273deg, #FFEFE9 0%, #FFA933 100%)',
    intro: '围绕业务与技术复合型人才这一广大企业当前数字化转型进程中重要人才空缺，开发业务技术复合型架构人才多层次培养体系与相关培训内容。'
  }
]

// 证书
function getCertsList (isMobile) {
  return [
    {
      sortImg: isMobile ? number01H5 : number01,
      title: '工业和信息化重点领域数字化转型产业人才基地',
      intro: [
        '2022 年 4 月，工信部直属单位电子工业出版社入围首批 “工业和信息化重点领域产业人才基地建设机构”，广泛面向国内重点产业领域、重点经济发展区域，征集、评估、授予标杆型数转产业人才基地，并积极参与支撑建设。',
        '极客邦科技作为该基地第一批标杆型数转产业人才基地的企业，通过 “研-测-学-考-评”一体化学习平台，服务广大企业数字化转型人才培养，赋能企业数字化转型取得实效，形成样板优秀案例。'
      ],
      certImg: isMobile ? cert1ImgH5 : cert1Img
    },
    {
      sortImg: isMobile ? number02H5 : number02,
      title: 'ICT 行业讲师评定认证项目',
      intro: [
        '“ICT 行业讲师评定认证项目” 由中国移动通信联合会立项、 中国移动通信联合会教育与考试中心和极客邦科技共同运营，委托北京邮电大学制定《 ICT 行业讲师评价体系及评定标准》。',
        'ICT 行业讲师评定将根据《 ICT 行业讲师评价体系及评定标准》，由评定专家委员会分别从 ICT 行业知识能力、战略实践能力、教学设计能力等维度进行审核和评定，共设初级讲师、中级讲师、高级讲师、专家级讲师四级认证。'
      ],
      certImg: isMobile ? cert2ImgH5 : cert2Img
    }
  ]
}

// 研究成果
const harvestList = [
  {
    title: '数字人才发展体系粮仓模型白皮书',
    img: harvest1Img,
    link: 'https://www.infoq.cn/minibook/WvG2KwN4tFfpjtTaxNve'
  },
  {
    title: '企业的数字化人才培养',
    img: harvest2Img,
    link: 'https://www.infoq.cn/minibook/VtToXfO6Fo0ULhtQeCsy'
  },
  {
    title: '2022 中国开源发展研究分析',
    img: harvest3Img,
    link: 'https://www.infoq.cn/minibook/DTAg4l8piWHrBGfU3der'
  }
]

// 付晓岩著作
const bookList = [
  {
    title: '企业级业务架构设计：方法论与实践',
    img: book1Img
  },
  {
    title: '聚合架构：面向数字生态的构件化企业架构',
    img: book2Img
  },
  {
    title: '银行数字化转型',
    img: book3Img
  }
]

// 付晓岩合著
const bookList2 = [
  {
    title: '银行数字化转型：路径与策略',
    img: book4Img
  },
  {
    title: '银行数字转型：方法与实践',
    img: book5Img
  },
  {
    title: '软件研发效能提升实践',
    img: book6Img
  }
]

// 付晓岩专栏
const columnList = [
  {
    title: '说透数字化转型',
    img: column1Img,
    sku: 100076501,
    link: `${config.timeServer}/column/intro/100076501`
  },
  {
    title: '人人都用得上的数字化思维课',
    img: column2Img,
    sku: 100113201,
    link: `${config.timeServer}/column/intro/100113201`
  }
]

// 研究院团队成员
const memberList = [
  {
    name: '李佳',
    intro: '极客邦双数研究院首席研究员',
    avatar: lijia
  },
  {
    name: '王一鹏',
    intro: '极客邦双数研究院高级研究员',
    avatar: wangyipeng
  },
  {
    name: '高玉娴',
    intro: '极客邦双数研究院高级研究员',
    avatar: gaoyuxian
  },
  {
    name: '阎婷',
    intro: '极客邦双数研究院高级研究员',
    avatar: yanting
  }
]

// 特聘专家
const expertList = [
  {
    avatar: chenxiaohua,
    name: '陈晓华',
    title: '中国移动通信联合会区块链专委会主任、西安交通大学国家大学科技园数字经济创新中心主任',
    introHtml: '中国经济年度领军人物、数字经济学家、现任中国移动通信联合会区块链专委会主任、西安交通大学国家大学科技园数字经济创新中心主任、工信部新基建重大项目评审专家。《北邮区块链技术丛书》总主编、中国科技体制改革研究会数字经济发展研究小组组长、中国电子北海产业园高级顾问。兼任清华大学、浙江大学、中央财经大学、北京工业大学等多所高校教授、导师、专家成员。雄安新区建设发展研究中心专家顾问。曾任北邮在线集团执行总裁、北邮在线数字经济研究院院长。',
    show: true,
  },
  {
    avatar: liushaoxuan,
    name: '刘少轩',
    title: '工业和信息化重点领域产业人才基地联合建设机构（电子工业出版社）负责人',
    introHtml: '电子工业出版社融合发展部企业服务业务负责人，工业和信息化重点领域产业人才基地联合建设机构（电子工业出版社）负责人。主导建设工业和信息化人才培养工程项目大数据应用专项技术培训，入围 2020 年北京市高精尖产业技能提升培训目录；支撑建设多个央企/区域数字化转型产业人才基地，参与多家国央企数字化转型人才体系化培养研究与实施工作。',
    show: false
  },
  {
    avatar: qiaoxinliang,
    name: '乔新亮',
    title: '彩食鲜 CTO、原苏宁科技集团副总裁、TGO 鲲鹏会荣誉导师',
    introHtml: '彩食鲜 CTO、原苏宁科技集团副总裁、TGO 鲲鹏会荣誉导师；IBM 认证架构师、全球技术学院成员、GITC 全球互联网技术大会主席团成员；多次出席 GTLC 全球技术领导力峰会，并被评为「全场最受欢迎讲师」；专注 IT 研发管理工作，在企业数字化转型、大型 IT 研发团队搭建和管理、卓越 IT 产品建设、IT 产品运营、中台及 DevOps 体系建设等方面都有丰富的经验。',
    show: false
  },
  {
    avatar: shenyang,
    name: '沈旸',
    title: '联易融副总裁',
    introHtml: '沈旸现任联易融副总裁，在咨询，交付，IT 管理和研发管理等领域有丰富的经验。曾任神州数码集团股份有限公司副总裁兼 CIO，云基地负责人，主要负责数字化转型、云基地建设和技术运营、营销私域运营等工作，领导云基础架构、区块链、量子应用、智能运维、分布式数据库、开源 ERP 等领域的开发管理和交付工作。',
    show: false
  },
  {
    name: '史凯',
    title: '精益数据方法论体系的创始人',
    introHtml: '精益数据方法论体系的创始人，针对企业数字化转型的挑战，原创发明了数据驱动的精益数据方法帮助众多企业探索场景，规划路径。拥有 20 年以上企业信息化架构，数字化转型咨询与实施经验，原阿里云智能中国区咨询总经理，先后从业于埃森哲、EMC、ThoughtWorks，曾任 EMC 中国区咨询总监，ThoughtWorks 数据智能总经理，行业数字化转型 KOL，个人微信公众号专业行业内粉丝 2 万人以上。发明了行业首个卡牌式数字化转型工作坊，在众多峰会和企业实践，获得了良好的反馈。',
    avatar: shikai,
    show: false
  },
  {
    avatar: wangnan,
    name: '王楠',
    title: '北京邮电大学教授',
    introHtml: '王楠博士，北京邮电大学教授，研究领域涵盖教育信息化、创新人才培养。主持和参与多项科技部、教育部、全国教育科学、北京教育科学、中国科协等科研项目，出版《学习设计》等多部专业书籍，发表国内外期刊、学术会议论文近 50 篇。',
    show: false
  },
  {
    avatar: wangwei,
    name: '王炜',
    title: '《银行数字化转型：方法与实践》主编、《银行数字化转型：路径与策略》副主编',
    introHtml: '《银行数字化转型：方法与实践》主编、《银行数字化转型：路径与策略》副主编 20 年媒体视角下的财经领域研究经历。自银行业信息科技“十二五”发展规划制定后，专注于金融科技领域研究。2017 年组建银行数字化转型课题组并担任负责人，2021 年发起成立数字银行论坛。',
    show: false
  },
  {
    avatar: xiangjiangxu,
    name: '向江旭',
    title: '前美的集团 IoT 副总裁兼 CTO',
    introHtml: '向江旭先生在软件、通信、互联网和物联网行业拥有 30 年专业经验，其中 18 年在美国硅谷。前美的集团 IoT 副总裁兼 CTO，更早前担任宜信公司高级副总裁兼 CTO、苏宁 IT 执行副总裁兼技术研究院院长、微软亚太研发集团主席助理兼集团技术战略总监，以及在硅谷思科、戴尔等公司担任技术管理职位，他也是美国匹兹堡大学校长全球顾问。<br>向先生领导了物联网、车联网、智能家居、智慧零售、AI、云和大数据技术在零售、金融和制造行业的应用创新，是数字化转型和创新的领军人物。',
    show: false
  },
  {
    avatar: zhuyingshao,
    name: '朱颖韶',
    title: '数字化转型企业资深人力资源专家',
    introHtml: '数字化转型企业资深人力资源专家，毕业于伦敦城市大学管理专业硕士，曾任美团高级人力资源总监、明略数据人力资源副总裁，曾在中外运－敦豪航空快件公司 DHL、美国 Aramark 服务产业（中国）有限公司担任人力资源总监 ；拥有 Mercer 薪酬管理专家认证；DDI 领导力认证讲师/DDI 目标选材认证讲师；高效能人士七个习惯认证讲师，MBTI 施测师认证， RTC 人才测评师认证等人力资源相关领域资质。擅长高管招聘及测评、组织发展、薪酬激励、人才梯队等人力资源体系搭建、组织数字化转型等领域。',
    show: false
  }
]

// 合作机构
const cooperationList = [
  '神州信息',
  '中电金信',
  '培训杂志',
  'GHR',
  '知链科技',
  '甫瀚咨讯',
  '远见教育',
  '电子工业出版社',
  '施耐德电气'
]

export {
  directionList,
  getCertsList,
  harvestList,
  bookList,
  bookList2,
  columnList,
  memberList,
  expertList,
  cooperationList
}
